<template>
  <span>
      <el-dialog
        
        title="Tips"
        :visible.sync="view.additionalDialog"
        width="30%"
        >
        <span>This is a message</span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="view.additionalDialog = false">Cancel</el-button>
            <el-button type="primary" @click="view.additionalDialog = false">Confirm</el-button>
        </span>
    </el-dialog>
  </span>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
export default {
    name: 'AdvancedAccount',
    components: {
        
    },
    props: {
        
    },
    data () {
        return {
           visible: false 
        }
    },
    methods: {
      
    },
    computed: {
      ...mapState('user', {
          view: 'view',
        }),
        
    },
}
</script>

<style lang="scss" scoped>

</style>
